/*
  Fix for SamsungInternet:
  TypeError: document.getElementsByClassName.ToString is not a function
  https://sentry.key-g.com/sentry/gettransfer/issues/8553/
  https://github.com/SamsungInternet/support/issues/56
*/
Function.prototype.ToString = function () { return this.toString(); }
